import Keycloak from 'keycloak-js';

const parseOrganizationRoles = (keycloak: Keycloak) => {
  let organizationRoles = null;
  if (keycloak.tokenParsed) {
    if (keycloak.tokenParsed['organization-role']) {
      organizationRoles = keycloak.tokenParsed['organization-role'];
    } else if (keycloak.tokenParsed['organizations']) {
      organizationRoles = keycloak.tokenParsed['organizations'];
    }
  }

  return organizationRoles;
};

export default parseOrganizationRoles;
